export const ONBOARDING_SEARCH_PARAM = 'onboarding';
export const ONBOARDING_VARIANT_SEARCH_PARAM = 'onboardingVariant';
